<svg
  width="33"
  height="35"
  viewBox="0 0 33 35"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M25.5749 18.15H5.77495C5.31955 18.15 4.94995 17.7804 4.94995 17.325C4.94995 16.8696 5.31955 16.5 5.77495 16.5H25.5749C26.0303 16.5 26.4 16.8696 26.4 17.325C26.4 17.7804 26.0303 18.15 25.5749 18.15Z"
    fill="currentColor"
  />
  <path
    d="M14.85 27.2246L14.85 7.42461C14.85 6.96921 15.2196 6.59961 15.675 6.59961C16.1304 6.59961 16.5 6.96921 16.5 7.42461L16.5 27.2246C16.5 27.68 16.1304 28.0496 15.675 28.0496C15.2196 28.0496 14.85 27.68 14.85 27.2246Z"
    fill="currentColor"
  />
</svg>
